import { Stack } from 'expo-router';

export default function VideoVotingStructureLayout() {
    return <Stack screenOptions={{ headerShown: false }} />;
}
